import React from 'react';
import "./Features.css"

const FeaturesCard = ({ even, imgUrl, heading, para }) => {
  return (
    <div className={`features-container ${even ? 'oddeven' : ''}`}>
      <div className='feature-card-ls'>
        <div className='feature-img'>
          <img src={imgUrl} alt='' />
        </div>
      </div>
      <div className='feature-card-rs'>
        <div className='feature-content-rs'>
          <div>
            <h3>{heading}</h3>
            <p>{para}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturesCard;


